export default "__VITE_ASSET__CRmXRRxw__"